import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/payroll/v1`;

export function getMany({
  offset = 0,
  limit = 15,
  payrollPeriod = "",
  isExport = false,
  projectId = null,
  search = "",
  date = "",
}) {
  let payslipUrl = `${url}/lists?offset=${offset}&limit=${limit}&isExport=${isExport}&payrollPeriod=${payrollPeriod}&search=${search}&date=${date}`;
  if (projectId) payslipUrl += `&projectId=${projectId}`
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: payslipUrl,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getCoshSharing({date = "", payrollPeriod = ""}) {
  let payslipUrl = `${url}/cost_sharing?isExport=true&date=${date}&payrollPeriod=${payrollPeriod}`;

  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: payslipUrl,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getOne(id) {
  const result = axios({
    method: "GET",
    url: `${url}/detail/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function insertNewRecord(data) {
  return axios({
    method: "POST",
    url: `${url}/create`,
    headers: getHeaders(),
    data,
  });
}

export function generatePayroll(date, resignedEmployeIds) {
  return axios({
    method: "POST",
    url: `${url}/generate?date=${date}&resignedEmployeIds=${resignedEmployeIds}`,
    headers: getHeaders()
  });
}

export function updateRecordById(id, dataToUpdate) {
  return axios({
    method: "PUT",
    url: `${url}/update/${id}`,
    headers: getHeaders(),
    data: dataToUpdate,
  });
}

export function processPayroll(dataToUpdate) {
  return axios({
    method: "PUT",
    url: `${url}/process`,
    headers: getHeaders(),
    data: dataToUpdate,
  });
}

export function submitPayroll(groupPayrollId) {
  return axios({
    method: "PUT",
    url: `${url}/submit_payroll/${groupPayrollId}`,
    headers: getHeaders()
  });
}

export function markAsRejected(groupPayrollId, comment,year) {
  return axios({
    method: "PUT",
    url: `${url}/mark_as_rejected/${groupPayrollId}?year=${year}`,
    headers: getHeaders(),
    data: {
      comment
    }
  });
}

export function markAsReviewed(groupPayrollId) {
  return axios({
    method: "PUT",
    url: `${url}/mark_as_verified/${groupPayrollId}`,
    headers: getHeaders()
  });
}

export function markAsApproved(groupPayrollId,year) {
  return axios({
    method: "PUT",
    url: `${url}/mark_as_approved/${groupPayrollId}?year=${year}`,
    headers: getHeaders()
  });
}

export function softDeleteById(id) {
  return axios({
    method: "DELETE",
    url: `${url}/archive/${id}`,
    headers: getHeaders(),
  });
}

export function changeSeverancepay(value) {
  console.log(value);
  return axios({
    method: "PUT",
    url: `${url}/changeSeverancePay`,
    headers: getHeaders(),
    data: value
  });
}

export function getPayslipById(id) {
  const result = axios({
    method: "GET",
    url: `${url}/payslip/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getFinalPaymentById(id) {
  const result = axios({
    method: "GET",
    url: `${url}/final_payment/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}
